import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { MessagesSquare, History } from 'lucide-react'
import type { AdminColumn } from '@/components/DataTable/types'
import { ModListScreen } from './ModListScreen'
import { makeFetcher, MOD_STR as S, type ContextMsgRow, type UserHistoryRow } from './modContentApi'

/**
 * A6.16 — Kontekst ko'rinishi. Bayroqlangan xabar ATROFIDAGI xabarlar (moderator
 * qarorni to'g'ri kontekstda qabul qiladi). Xabar ID `?message=` orqali beriladi
 * → GET /admin/moderation/context?message_id=. ID yo'q bo'lsa navbat bo'sh.
 */
export function ContextViewScreen() {
  const [sp] = useSearchParams()
  const messageId = sp.get('message') ?? ''
  const columns = useMemo<AdminColumn<ContextMsgRow>[]>(
    () => [
      { key: 'seq', header: S.seq, type: 'number' },
      { key: 'sender', header: S.sender, type: 'text' },
      { key: 'text', header: S.text, type: 'longtext' },
      { key: 'is_target', header: S.targetMsg, type: 'bool' },
      { key: 'sent_at', header: S.sentAt, type: 'date' },
    ],
    [],
  )
  const fetcher = useMemo(
    () =>
      makeFetcher<ContextMsgRow>(
        '/admin/moderation/context',
        'messages',
        (r) => `${r.sender} ${r.text}`,
        () => (messageId ? { message_id: messageId } : undefined),
      ),
    [messageId],
  )
  return (
    <ModListScreen<ContextMsgRow>
      screenId="A6.16"
      title={S.context}
      description={messageId ? `${S.contextDesc} · #${messageId}` : S.contextPrompt}
      columns={columns}
      fetcher={fetcher}
      rowId={(r) => String(r.id)}
      icon={<MessagesSquare size={28} strokeWidth={1.5} />}
    />
  )
}

/**
 * A6.17 — Foydalanuvchi tarixi (yon panel). Foydalanuvchining oldingi moderatsiya
 * harakatlari (shikoyat/strike/qaror). Foydalanuvchi ID `?user=` orqali →
 * GET /admin/moderation/user-history?user_id=.
 */
export function UserHistoryPanelScreen() {
  const [sp] = useSearchParams()
  const userId = sp.get('user') ?? ''
  const columns = useMemo<AdminColumn<UserHistoryRow>[]>(
    () => [
      { key: 'id', header: 'ID', type: 'id' },
      { key: 'kind', header: S.kind, type: 'text' },
      { key: 'category', header: S.category, type: 'text' },
      { key: 'action', header: S.action, type: 'text' },
      { key: 'actor', header: S.actor, type: 'text' },
      { key: 'created_at', header: S.created, type: 'date' },
    ],
    [],
  )
  const fetcher = useMemo(
    () =>
      makeFetcher<UserHistoryRow>(
        '/admin/moderation/user-history',
        'items',
        (r) => `${r.kind} ${r.category} ${r.action}`,
        () => (userId ? { user_id: userId } : undefined),
      ),
    [userId],
  )
  return (
    <ModListScreen<UserHistoryRow>
      screenId="A6.17"
      title={S.userHistory}
      description={userId ? `${S.userHistoryDesc} · #${userId}` : S.userPrompt}
      columns={columns}
      fetcher={fetcher}
      rowId={(r) => String(r.id)}
      icon={<History size={28} strokeWidth={1.5} />}
    />
  )
}
